import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Button, Col, Form, Modal, Row, Spinner, Alert } from '@themesberg/react-bootstrap';
import { batchPayReward } from "../../../../../controller/api/__classic__/reward";

export default (props) => {

  const selectedIds = props.selectedIds || []

  const [cookies] = useCookies(['lottmekong'])

  const [status, setStatus] = useState(0) // 0: idle, -1: loading, 1: success, 2: error

  const [method, setMethod] = useState('REWARD')

  const [result, setResult] = useState(null)

  const batchPaidPress = async () => {
    if (selectedIds.length === 0) {
      alert('Vui lòng chọn ít nhất một mục')
      return
    }

    setStatus(-1)
    setResult(null)

    const response = await batchPayReward(cookies.lottmekong, selectedIds, method)

    if (response && response.status === 1) {
      setStatus(1)
      setResult(response)
    } else {
      setStatus(2)
      setResult(null)
    }
  }

  const onMethodSelect = (evt) => {
    setMethod(evt.target.value)
  }

  useEffect(() => {
    if (props.show) {
      setStatus(0)
      setResult(null)
      setMethod('REWARD')
    }
  }, [props.show])

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 'normal', fontSize: 15 }} id="contained-modal-title-vcenter">
          Trả thưởng hàng loạt ({selectedIds.length} mục)
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {status === 1 && result && (
          <Alert variant="success">
            <strong>Thành công!</strong> Đã trả thưởng {result.successCount} mục
            {result.failCount > 0 && <>, thất bại {result.failCount} mục</>}
          </Alert>
        )}

        {status === 2 && (
          <Alert variant="danger">
            <strong>Lỗi!</strong> Không thể xử lý trả thưởng hàng loạt
          </Alert>
        )}

        <Row>
          <Col md={3} className='text-left align-self-center'>
            <Form.Label>Hình thức</Form.Label>
          </Col>
          <Col md={9}>
            <Form.Select onChange={onMethodSelect} value={method} disabled={status === -1 || status === 1}>
              <option value={'REWARD'}>Chuyển về ví thưởng</option>
              <option value={'INTERNAL'}>Chuyển về ví chơi</option>
            </Form.Select>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <p className="text-muted mb-0">
              <strong>Lưu ý:</strong> Trả thưởng hàng loạt không hỗ trợ phương thức ngân hàng.
              Vui lòng sử dụng trả thưởng đơn lẻ cho phương thức này.
            </p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        {status === -1 && (
          <Spinner animation="border" size="sm" className="me-2" />
        )}
        <b>
          {status === 1 ? 'Xong' : status === 2 ? 'Không thành công' : status === -1 ? 'Đang xử lý...' : ''}
        </b>
        &nbsp;
        {status !== 1 && (
          <Button variant="success" onClick={batchPaidPress} disabled={status === -1}>
            {status === -1 ? 'Đang xử lý...' : 'Trả thưởng'}
          </Button>
        )}
        <Button variant="danger" onClick={() => props.onHide(result)} disabled={status === -1}>
          {status === 1 ? 'Đóng' : 'Hủy'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
